import {
  call,
  takeLatest
} from "redux-saga/effects";
import {
  downloadXLSFile
} from "utils/api";
import {
  defaultReturn,
  makePayload,
  generateDefaultActions
} from "store/utils/helpers";

export const EXPORT_PREPAYMENT_SCHEDULES = generateDefaultActions("EXPORT_PREPAYMENT_SCHEDULES");
export const exportPrepaymentSchedules = payload => makePayload(EXPORT_PREPAYMENT_SCHEDULES.value, payload);
function* exportPrepaymentSchedulesSaga(payload) {
  const url = `loans/${payload.id}/exportPrepaymentSchedules`;
  yield call(downloadXLSFile, url, "POST", payload, "");
}

const initialState = {
  prepaymentSchedules: {

  }
};

export default function prepaymentSchedulesReducer(state = initialState, action) {
  const {
    type,
    payload,
    subKey
  } = action;
  switch (type) {
    case EXPORT_PREPAYMENT_SCHEDULES.success:
      return defaultReturn(state, payload.data, "prepaymentSchedules");
    default:
      return state;
  }
}

export function* prepaymentSchedulesSaga() {
  yield takeLatest(EXPORT_PREPAYMENT_SCHEDULES.value, exportPrepaymentSchedulesSaga);
}
